import { render, staticRenderFns } from "./AreaOfWorkSalaryRange.vue?vue&type=template&id=30ac0d00&scoped=true&"
import script from "./AreaOfWorkSalaryRange.vue?vue&type=script&lang=js&"
export * from "./AreaOfWorkSalaryRange.vue?vue&type=script&lang=js&"
import style0 from "./AreaOfWorkSalaryRange.vue?vue&type=style&index=0&id=30ac0d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ac0d00",
  null
  
)

export default component.exports